import {
  Center,
  Image,
  useColorModeValue,
  IconButton,
  VStack,
} from "@chakra-ui/react";
import { FaBookOpen, FaFileLines } from "react-icons/fa6";
import React from "react";

const Navigation = ({ activeView, onViewChange }) => {
  const views = [
    { id: "summary", icon: FaFileLines, label: "Summary" },
    { id: "script", icon: FaBookOpen, label: "Script" },
  ];

  return (
    <VStack
      bg={useColorModeValue("gray.50", "navy.900")}
      borderRight="1px solid"
      borderRightColor={useColorModeValue("gray.200", "gray.700")}
      h="100%"
      p={2}
      spacing={2}
    >
      <Center mb={10}>
        <Image alt="Magic Seven Logo" h="40px" src="/logo.png" w="40px" />
      </Center>
      {views.map((view) => {
        const Icon = view.icon;
        return (
          <IconButton
            aria-label={view.label}
            colorScheme={activeView === view.id ? "blue" : "gray"}
            icon={<Icon />}
            key={view.id}
            onClick={() => onViewChange(view.id)}
            size="md"
            variant={activeView === view.id ? "solid" : "ghost"}
          />
        );
      })}
    </VStack>
  );
};

export default Navigation;
